import { Button, Input, notification, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { accountType, bankNameList, companyType, getYears, Months } from "../common";
import { DeleteOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Indentity = () => {
    const [error, setError] = useState({});
    const urlParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [row, setRows] = useState([
        {
            month: 'January',
            year: new Date().getFullYear(),
            amount: 0,
        }
    ]);
    const [data, setData] = useState({
        entityName: '',
        pan: '',
        companyType: '',
        bankName: '',
        accountType: '',
        accountNumber: '',
        cc: '',
        inhouse: '',
        loanRef: '',
    })
    const navigate = useNavigate();

    useEffect(()=>{
        getInitialVal();
    },[])
    const getInitialVal = async () => {
        setLoading(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/get_client_identity?user_id=${localStorage.getItem('user_id') || ''}`);

            if (response.ok) {
                const responseData = await response.json();
                setData(
                    {...data,
                    pan:responseData?.analysis_results?.pan?.value,
                    accountNumber:responseData?.analysis_results?.account_number?.value
                   })
                setLoading(false);
            } else {
                setLoading(false);
                notification.error({
                    message: 'Error',
                    description: 'Unable to fetch client data.',
                    placement: 'topRight',  // you can choose: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
                });
            }

        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Unable to fetch client data.',
                placement: 'topRight',  // you can choose: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
            });
            console.error(error);
            setLoading(false);
        }
    }
    const verify = () => {
        if (data.entityName || data.pan || data.companyType || data.bankName || data.accountType || data.accountNumber || data.cc || data.inhouse) {
            return true;
        } else {
            const message = 'Fill up required field.'
            // setError({
            //     ...error,
            //     entityName: data?.entityName ? '' : message,
            //     pan: data?.pan ? '' : message,
            //     companyType: data?.companyType ? '' : message,
            //     bankName: data?.bankName ? '' : message,
            //     accountType: data?.accountType ? '' : message,
            //     accountNumber: data?.accountNumber ? '' : message,
            //     cc: data?.cc ? '' : message,
            //     inhouse: data?.inhouse ? '' : message,
            // })
            return false
        }
    }

    const save = async () => {
        const user_id = urlParams.get('user_id');
        if (!verify()) {
            navigate('/chat?user_id=' + encodeURI(user_id));
            return;
        }
        setLoading(true);
        const save_data = {
            user_id: user_id,
            entity_name: data?.entityName,
            pan: data?.pan,
            company_type: data?.companyType,
            bank_name: data?.bankName,
            account_type: data?.accountType,
            account_number: data?.accountNumber,
            cc_od_limit: data?.cc || 0,
            currency: 'INR',
            monthly_drawing_power: row,
            keywords_for_inhouse: data?.inhouse,
            loan_ref_no: data?.loanRef || ''
        };
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/get_user_identity`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(save_data),
                }
            );
            if (response.ok) {
                const reciveData = await response.json();
                notification.success({
                    message: 'Successful',
                    description: reciveData?.message || '',
                    placement: 'topRight',  // you can choose: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
                });
                setLoading(false);
            } else {
                notification.error({
                    message: 'Error',
                    description: 'Unable to save data.',
                    placement: 'topRight',  // you can choose: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
                });
                setLoading(false);
            }
        } catch (error) {
            console.error(error)
        }finally{
            navigate('/chat?user_id=' + encodeURI(user_id));
            
        }
    }
    const addRow = () => {
        setRows((prev) => {
            return [...prev, { month: 'January', year: new Date().getFullYear(), amount: 0, }]
        })
    }
    const remove = (idx) => {
        setRows((prev) => {
            const newData = [];
            prev.map((data, index) => {
                if (idx !== index) {
                    newData.push(data);
                }
            })
            return newData;
        })
    }
    const resetAll = () => {
        setRows([{ month: 'January', year: new Date().getFullYear(), amount: 0, }])
    }
    const rowUpdate = (idx, whom, val) => {
        setRows((prev) => {
            const newData = []
            prev.map((data, index) => {
                if (idx === index) {
                    newData.push({ ...data, [whom]: val })
                } else {
                    newData.push(data);
                }
            })
            return newData;
        })
    }
    const dataUpdate = (whom, val) => {
        setData({ ...data, [whom]: val })
    }
    return (
        <Spin spinning={loading}>
            <div className="w-full p-5 flex flex-wrap gap-4" >
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">Entity Name<span className="text-red-500">*</span></p>
                    <div>
                        <Input placeholder="Enter Entity Name" onChange={(e) => dataUpdate('entityName', e.target.value)} />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.entityName}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">PAN<span className="text-red-500">*</span></p>
                    <div>
                        <Input placeholder="Enter PAN Number" value={data?.pan} onChange={(e) => dataUpdate('pan', e.target.value)} />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.pan}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">Company Type<span className="text-red-500">*</span></p>
                    <div>
                        <Select
                            // showSearch
                            placeholder="Select Company Type"
                            optionFilterProp="label"
                            className="w-full"
                            onChange={(e) => dataUpdate('companyType', e)}
                            // onSearch={onSearch}
                            options={companyType}
                        />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.companyType}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">Bank Name<span className="text-red-500">*</span></p>
                    <div>
                        <Select
                            // showSearch
                            placeholder="Select Bank Name"
                            optionFilterProp="label"
                            className="w-full"
                            onChange={(e) => dataUpdate('bankName', e)}
                            // onSearch={onSearch}
                            options={bankNameList}
                        />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.bankName}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">Account Type<span className="text-red-500">*</span></p>
                    <div>
                        <Select
                            // showSearch
                            placeholder="Select Account Type"
                            optionFilterProp="label"
                            className="w-full"
                            onChange={(e) => { dataUpdate('accountType', e) }}
                            // onSearch={onSearch}
                            options={accountType}
                        />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.accountType}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">Account Number<span className="text-red-500">*</span></p>
                    <div>
                        <Input placeholder="Enter Account Number" value={data.accountNumber} onChange={(e) => dataUpdate('accountNumber', e.target.value)} />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.accountNumber}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">CC/OD<span className="text-red-500">*</span></p>
                    <div className="flex justify-between">
                        <Input className="w-[75%]" placeholder="Enter CC/OD" onChange={(e) => dataUpdate('cc', e.target.value)} />
                        <Select
                            defaultValue="INR"
                            optionFilterProp="label"
                            className="w-[20%]"
                            disabled
                            // onChange={onChange}
                            // onSearch={onSearch}
                            options={[
                                {
                                    value: 'INR',
                                    label: 'INR',
                                },
                            ]}
                        />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error.cc}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[70px]">
                    <p className="text-xs mb-1 font-bold text-zinc-600">Keywords For Inhouse<span className="text-red-500">*</span></p>
                    <div>
                        <Input onChange={(e) => { dataUpdate('inhouse', e.target.value) }} placeholder="Enter keywords for inhouse" />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.inhouse}</p>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[170px] rounded-sm" style={{ border: '1px solid #dedede' }}>
                    <div className="flex justify-between px-3 py-2 items-center">
                        <p className="text-xs mb-1 font-bold text-black">Monthly Drawing Power Limit<span className="text-red-500">*</span></p>
                        <Select
                            defaultValue="INR"
                            optionFilterProp="label"
                            className="w-[20%]"
                            disabled
                            // onChange={onChange}
                            // onSearch={onSearch}
                            options={[
                                {
                                    value: 'INR',
                                    label: 'INR',
                                },
                            ]}
                        />
                        <div>
                            <div className="bg-slate-100 rounded-sm text-sky-500 inline-block text-xs mx-1 px-3 py-1 cursor-pointer font-bold" onClick={() => resetAll()}>Reset</div>
                            <div className="bg-slate-100 rounded-sm text-sky-500 inline-block text-xs mx-1 px-3 py-1 cursor-pointer font-bold" onClick={() => { addRow() }}>+ Add Row</div>
                        </div>
                    </div>
                    <div className="h-[110px] mx-3 overflow-auto" style={{ borderTop: '1px solid #dedede' }}>
                        {row.map((data, idx) => (
                            <div className="w-full flex justify-between items-center mt-1" key={`dropDown ${idx}`}>
                                <Select
                                    defaultValue={data.month}
                                    value={data.month}
                                    optionFilterProp="label"
                                    className="w-[28%]"
                                    onChange={(e) => { rowUpdate(idx, 'month', e) }}
                                    options={Months}
                                />
                                <Select
                                    defaultValue={data.year}
                                    value={data.year}
                                    optionFilterProp="label"
                                    className="w-[28%]"
                                    onChange={(e) => { rowUpdate(idx, 'year', e) }}
                                    options={getYears()}
                                />
                                <Input className="w-[28%]" placeholder="Enter Amount" value={data.amount} onChange={(e) => { rowUpdate(idx, 'amount', e.target.value) }} />
                                <DeleteOutlined className=" text-red-600 cursor-pointer" style={{ fontSize: '16px' }} onClick={() => remove(idx)} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="w-[40vw] min-w-[300px]  inline-block h-[170px] relative">
                    <p className="text-xs mb-1 font-bold text-zinc-600">Loan Ref. No/Application Id{' (Optional)'}</p>
                    <div>
                        <Input placeholder="Enter Loan Ref. No/Application Id" onChange={(e) => dataUpdate('loanRef', e.target.value)} />
                    </div>
                    <p className="text-[10px] mt-1 text-red-600 h-3">{error?.loanRef}</p>
                    <Button
                        className="absolute bg-blue-600 text-white"
                        style={{ right: '0px', bottom: '0px' }}
                        onClick={() => { save() }}
                        loading={(loading && data?.accountNumber)}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </Spin>
    );
}
export default Indentity;